import { db } from "../../../mp-database"
import getTruthyKeys from "../getTruthyKeys"
import parseSnapshot from "../parseSnapshot"
import { values } from "mout/object"

export default function markGUAsAsNeedingUpdate(
  student,
  assessmentId,
  record = {}
) {
  if (!student) return Promise.reject()

  function findTeachersWithClasses(educatorsSnapshot, classes) {
    const teachersWithClasses = {}
    const educators = values(parseSnapshot(educatorsSnapshot))
    educators.forEach(educator => {
      if (!educator.classes) return
      classes.forEach(cl => {
        if (educator.classes[cl]) {
          teachersWithClasses[educator.id] = true
        }
      })
    })
    return teachersWithClasses
  }

  const classes = getTruthyKeys(student.classes)
  //if the current class is not in student's classes object, then its added to classes array
  //To change the updated status in GUA
  if (record && !classes.includes(record.id)) {
    classes.push(record.id)
  }

  return db
    .collection("educators")
    .where("school", "==", student.school)
    .get()
    .then(educatorsSnapshot => {
      const teachers = Object.keys(
        findTeachersWithClasses(educatorsSnapshot, classes)
      )
      const groupUAIds = [
        student.schoolDistrict,
        student.school,
        ...classes,
        ...teachers
      ].filter(id => id !== undefined)

      const updatedGroupUAs = {}

      const updates = groupUAIds.map(groupUAId => {
        // const GUAId = `${groupUAId}_${assessmentId}_${year}`
        return db
          .collection("groupUAs")
          .where("groudId", "==", groupUAId)
          .where("assessmentId", "==", assessmentId)
          .get()
          .then(async docs => {
            let count = 0
            let batch = db.batch()

            docs.forEach(async doc => {
              const data = doc.data()
              if (data && !data.deleted && data.scoring) {
                batch.set(doc.ref, { [`updated`]: false }, { merge: true })
                data.updated = false

                count++

                if (count >= 480) {
                  // eslint-disable-next-line no-await-in-loop
                  await batch.commit()
                  batch = db.batch()
                  count = 0
                }

                updatedGroupUAs[data.id] = data
              }
            })

            if (count > 0) {
              return batch.commit()
            }
          })
      })

      return Promise.all(updates).then(() => {
        return updatedGroupUAs
      })
    })
}
